import { jsx as r } from "react/jsx-runtime";
import d from "classnames";
import i from "styled-components";
import o from "../../../utils/colors.js";
import { device as e } from "../../../utils/device.js";
const l = i.a`
  color: ${o.white};
  border: none;
  padding: 14px 0;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  background: transparent;
  display: flex;
  justify-content: flex-start;
  outline-color: ${o.orange};
  text-decoration: none;
  flex-basis: 100%;

  &:hover,
  &:focus {
    color: ${o.orange};
  }

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }

  @media ${e.isTablet}, ${e.isDesktop} {
    flex: 0 50%;

    &:first-child {
      padding-top: 14px;
    }

    &:last-child {
      padding-bottom: 14px;
    }
  }
`, c = i.span`
  line-height: 1.4em;
`, g = ({ text: n, link: s, className: t = "", onClick: a = () => {
} }) => /* @__PURE__ */ r(l, { href: s, onClick: a, className: d({ [t]: !!t }), children: /* @__PURE__ */ r(c, { children: n }) });
export {
  g as default
};
